/* unplugin-vue-components disabled */import { render } from "./tags-view.vue?vue&type=template&id=c3c49db0&scoped=true&ts=true"
import script from "./tags-view.vue?vue&type=script&lang=ts"
export * from "./tags-view.vue?vue&type=script&lang=ts"

import "./tags-view.vue?vue&type=style&index=0&id=c3c49db0&lang=scss"
import "./tags-view.vue?vue&type=style&index=1&id=c3c49db0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3c49db0"]])

export default __exports__